(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vi", [], factory);
	else if(typeof exports === 'object')
		exports["vi"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["vi"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 